export const getAuthDropdownItems = (history, logoutCallback) => [
    {
        title: 'My Account',
        action: () => history.push('/profile'),
    },
    {
        title: 'Settings',
        action: () => history.push('/settings'),
    },
    {
        title: 'Logout',
        action: () => logoutCallback(),
    },
];

export const getNotAuthDropdownItems = (history) => [
    {
        title: 'Login',
        action: () => history.push('/login'),
    },
];
